import DynamicDropdown from "../../../Components/Dropdown/DynamicDropdown";
import { getStepInstruments } from "../../../Requests/stepRequests";
import { PositionType } from "../../../Interfaces/optionDomain";
import { getGroups } from "../../../Requests/optionDomain";
import { DropdownItem } from "../../../Interfaces/dropdownInterfaces";
import CheckBox from "../../../Components/Checkbox";
import { getBaseInstruments } from "../../../Requests/Order/tradeTableRequests";
import TextInput from "../../../Components/TextInput";
import Button from "../../../Components/Button";
import DynamicMultiSelectDropdown from "../../../Components/Dropdown/DynamicMultiSelectDropdown";
import { StaticMultiSelectDropdown } from "../../../Components/Dropdown/StaticMultiSelectDropdown";
import { IPortfoPairPositionSearchParam } from "../../../Interfaces/deltaHedgeAccounts";
import { getDeltaHedgeAccountsForPortfoDropdown } from "../../../Requests/deltaHedgeAccounts";
import { useState } from "react";

interface IProps {
  searchParamChangeHandler: (name: string, value: any) => void;
  searchParam: IPortfoPairPositionSearchParam;
  onSubmit: () => void;
}

const PortfoPairPositionSearchParamUI = ({
  searchParam,
  searchParamChangeHandler,
  onSubmit,
}: IProps) => {
  const [selectAllUsersOnLoad, setSelectAllUsersOnLoad] = useState(true);

  const userIdsChangeHandler = (name: string, value: any) => {
    setSelectAllUsersOnLoad(false);
    searchParamChangeHandler(name, value);
  };

  const positionTypeOptions: DropdownItem[] = [
    { id: PositionType.CS, name: "CS" },
    { id: PositionType.LS, name: "LS" },
    { id: PositionType.PS, name: "PS" },
    { id: PositionType.SS, name: "SS" },
    { id: PositionType.CC, name: "CC" },
    { id: PositionType.PP, name: "PP" },
  ];

  return (
    <div className="border border-gray-300 rounded p-3 grid grid-cols-2 gap-3 !w-[330px] !min-w-[330px]">
      <DynamicMultiSelectDropdown
        dropdown={{
          placeholder: "کاربر ها",
          name: "userIds",
          extraLabel: true,
        }}
        value={searchParam.userIds}
        onChange={userIdsChangeHandler}
        allDefaultValue={selectAllUsersOnLoad}
        getData={getDeltaHedgeAccountsForPortfoDropdown}
      />
      <div />
      <DynamicMultiSelectDropdown
        dropdown={{
          name: "groupId",
          placeholder: "گروه",
          extraLabel: true,
        }}
        getData={getGroups}
        onChange={searchParamChangeHandler}
        value={searchParam.groupId}
      />
      <StaticMultiSelectDropdown
        name="positionType"
        label="نوع پوزیشن"
        extraLabel
        items={positionTypeOptions}
        withSelectAll
        onChange={searchParamChangeHandler}
        value={searchParam.positionType}
      />
      <CheckBox
        checked={searchParam.sameStrikePrice}
        label="قیمت اعمال یکسان"
        name="sameStrikePrice"
        onChange={searchParamChangeHandler}
      />
      <div />
      <CheckBox
        checked={searchParam.sameKind}
        label="الزام به هم جنس بودن"
        name="sameKind"
        onChange={searchParamChangeHandler}
      />
      <CheckBox
        checked={searchParam.sameDueDate}
        label="الزام به هم رسید بودن"
        name="sameDueDate"
        onChange={searchParamChangeHandler}
      />
      <DynamicDropdown
        dropdown={{
          name: "ins1",
          placeholder: "نماد 1",
          extraLabel: true,
        }}
        getData={getStepInstruments}
        onChange={searchParamChangeHandler}
        value={searchParam.ins1}
      />
      <DynamicDropdown
        dropdown={{
          name: "ins2",
          placeholder: "نماد 2",
          extraLabel: true,
        }}
        getData={getStepInstruments}
        onChange={searchParamChangeHandler}
        value={searchParam.ins2}
      />
      <DynamicDropdown
        dropdown={{
          name: "baseIns1",
          placeholder: "نماد پایه 1",
          extraLabel: true,
        }}
        getData={() => getBaseInstruments()}
        onChange={searchParamChangeHandler}
        value={searchParam.baseIns1}
      />
      <DynamicDropdown
        dropdown={{
          name: "baseIns2",
          placeholder: "نماد پایه 2",
          extraLabel: true,
        }}
        getData={() => getBaseInstruments()}
        onChange={searchParamChangeHandler}
        value={searchParam.baseIns2}
      />
      <TextInput
        label="حداقل % بازده روزانه"
        onChange={searchParamChangeHandler}
        name="minProfitLock"
        value={searchParam.minProfitLock?.toString()}
        extraLabel
        kind="negativeDecimalNumbers"
      />
      <TextInput
        label="حداکثر % بازده روزانه"
        onChange={searchParamChangeHandler}
        name="maxProfitLock"
        value={searchParam.maxProfitLock?.toString()}
        extraLabel
        kind="negativeDecimalNumbers"
      />

      <TextInput
        label="حداکثر ٪ ریهج"
        onChange={searchParamChangeHandler}
        name="maxReHedgeRatio"
        value={searchParam.maxReHedgeRatio?.toString()}
        extraLabel
        kind="negativeDecimalNumbers"
      />
      <div />
      <TextInput
        label="حداقل روز تا سررسید(اول)"
        onChange={searchParamChangeHandler}
        name="lessMinRemainingDay"
        value={searchParam.lessMinRemainingDay?.toString()}
        extraLabel
        kind="negativeDecimalNumbers"
      />
      <TextInput
        label="حداکثر روز تا سررسید(اول)"
        onChange={searchParamChangeHandler}
        name="lessMaxRemainingDay"
        value={searchParam.lessMaxRemainingDay?.toString()}
        extraLabel
        kind="negativeDecimalNumbers"
      />
      <TextInput
        label="حداقل روز تا سررسید(دوم)"
        onChange={searchParamChangeHandler}
        name="moreMinRemainingDay"
        value={searchParam.moreMinRemainingDay?.toString()}
        extraLabel
        kind="negativeDecimalNumbers"
      />
      <TextInput
        label="حداکثر روز تا سررسید(دوم)"
        onChange={searchParamChangeHandler}
        name="moreMaxRemainingDay"
        value={searchParam.moreMaxRemainingDay?.toString()}
        extraLabel
        kind="negativeDecimalNumbers"
      />
      <TextInput
        label="حداقل ضریب هج"
        onChange={searchParamChangeHandler}
        name="minHedgeFactor"
        value={searchParam.minHedgeFactor?.toString()}
        extraLabel
        kind="negativeDecimalNumbers"
      />
      <TextInput
        label="حداکثر ضریب هج"
        onChange={searchParamChangeHandler}
        name="maxHedgeFactor"
        value={searchParam.maxHedgeFactor?.toString()}
        extraLabel
        kind="negativeDecimalNumbers"
      />
      <TextInput
        name="minYesterdayValue"
        label="حداقل ارزش معاملاتی روز قبل"
        extraLabel
        onChange={searchParamChangeHandler}
        value={searchParam?.minYesterdayValue?.toString() || ""}
        kind="price"
      />

      <TextInput
        name="minLastTradeValue"
        label="حداقل حجم معاملات روز قبل"
        extraLabel
        onChange={searchParamChangeHandler}
        value={searchParam?.minLastTradeValue?.toString() || ""}
        kind="price"
      />
      <div />
      <Button onClick={onSubmit} text="جستجو" variant="contained" />
    </div>
  );
};

export default PortfoPairPositionSearchParamUI;
